import React, {Component, Fragment} from 'react'
import SearchFilter from "../../../Templates/SearchFilter"
import { SORT, toggleSorting } from "../../../Templates/functions"
import { DeviceListSkeleton } from '../../../Templates/icons'
import FormRow from '../../../Templates/FormRow'
import {renderActionIcon} from './authorization_functions'
import AuthFilterModal from './AuthFilterModal'
import { renderDeviceIcon } from '../../../Templates/functions'
class DeviceList extends Component {
    state = {
        filteredDevices: [],
        sortingByName: 2,
        sortingById: 2,
        sortingByOnlineStatus: 2,
        filteringByAuthStatus: false,
        checkBoxes: {"1": true, "0": true, "-1": true},
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.loading !== this.props.loading) {
            this.getFirstDevice();
        }
    }

    getFirstDevice = () =>{
        let firstDeviceSelected = false;
        let rowData = this.props.devices.map(device => {
            if(!firstDeviceSelected){
                firstDeviceSelected = true;
                this.selectDevice(device._id)               
            }
        })
    }

    filterDevicesList = (searchText, index) => {
        if (searchText === "") {
            this.setState(prevState => ({
                filteredDevices: [],
                filteringDevices: false,
                searchText: "",
            }))
        }

        if (searchText) {
            let devices = this.filterDevices(searchText)
            this.setState(prevState => ({
                filteredDevices: devices,
                filteringDevices: true,
                searchText
            }))
        }
    }

    filterDevices = (searchText) => {
        let devicesList = this.props.devices
        let devicesWithMatch = devicesList.filter(device => {
            let name = device.nickname || device.name
            let nameMatch = name.toLowerCase().includes(searchText)
            return nameMatch
        })

        return devicesWithMatch
    }

    selectDevice = (id) => {
        this.props.selectDevice(id)
    }

    handleCheckBox = (e, auth) => {
        e.stopPropagation()
        let checkBoxes = this.state.checkBoxes
        if (checkBoxes[auth]) {
            checkBoxes[auth] = false
        } else {
            checkBoxes[auth] = true
        }
        let checkValues = Object.values(checkBoxes)
        let isFiltering = checkValues.some(value => value === true)
        if (isFiltering) {
            return this.setState({
                checkBoxes
            })
        }
    }

    renderDevicesList = () => {
        if (this.props.loading) {
            let rowData = [DeviceListSkeleton, DeviceListSkeleton, DeviceListSkeleton, DeviceListSkeleton, DeviceListSkeleton, DeviceListSkeleton]
            return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={["Name", "ID", "Status", ""]}
                    filterCBs={[null, null, null, true]}
                    callbacks={[() => null]}
                    states={[]}
                    widths={["40%", "40%", "12.5%", "5%"]}
                />
                <div id="rows-container">
                    {rowData.map((row, index) => {
                        return <FormRow
                            key={index}
                            rowData={row}
                            widths={["40%", "40%", "12.5%", "5%"]}
                            selectRow={() => null}
                            isSelected={null}
                            centeredIndices={[1, 2]}
                        />
                    })}
                </div>
            </Fragment>
        } else {     
        // this.focusScroll(this.props.selectedWorkInstructionId)   
        let devicesList
        let filteredDevices = this.state.filteredDevices

        if (this.state.filteringDevices) {
            devicesList = filteredDevices
        } else {
            devicesList = this.props.devices || []
        }

        if (this.state.sortingByName) {
            devicesList = SORT(this.state.sortingByName, devicesList, "nickname")
        }
        if (this.state.sortingById) {
            devicesList = SORT(this.state.sortingById, devicesList, "name")
        }
        if (this.state.sortingByOnlineStatus) {
            devicesList = SORT(this.state.sortingByOnlineStatus, devicesList, "activityStatus")
        }
        devicesList = devicesList.filter(device => this.state.checkBoxes[device.authorized])

        let deviceIds = []
        let isSelected = {}
        let rowData = devicesList.map(device => {
            isSelected[device.name] = device === this.props.selectedDevice
            let data = []
            data.push(<span className="flex" style={{alignItems: "center"}}>{renderDeviceIcon(device.type)}<p style={{marginLeft: '.25em'}}>{device.nickname}</p></span>)
            data.push(device.name)
            data.push(<p style={{textAlign: "center"}}>{this.props.renderActivityIcon(device.activityStatus)}</p>)
                
            data.push(<p style={{textAlign: "center"}}>{renderActionIcon(device.authorized, () => null)}</p>)
            deviceIds.push(device._id)
            return data
        })

        return <Fragment>
                <FormRow
                    isHeader={true}
                    rowData={["Name", "ID", "Status", ""]}
                    callbacks={[() => toggleSorting(this.state.sortingByName,
                        (value) => this.setState({
                            sortingByName: value,
                            sortingById: 0,
                            sortingByOnlineStatus: 0,
                            sortingByAuthStatus: 0
                        })
                    ), () => toggleSorting(this.state.sortingById,
                        (value) => this.setState({
                            sortingByName: 0,
                            sortingById: value,
                            sortingByOnlineStatus: 0,
                            sortingByAuthStatus: 0
                        })),
                        () => toggleSorting(this.state.sortingByOnlineStatus,
                            (value) => this.setState({
                                sortingByName: 0,
                                sortingById: 0,
                                sortingByOnlineStatus: value,
                                sortingByAuthStatus: 0
                            })
                        ), null]}
                        filterCBs={[null, null, null,
                            <AuthFilterModal
                                handleCheckBox={this.handleCheckBox}
                                checkBoxes={this.state.checkBoxes}
                        />]}
                        states={[this.state.sortingByName, this.state.sortingById, this.state.sortingByOnlineStatus, this.state.sortingByAuthStatus]}
                        widths={["40%", "40%", "12.5%", "5%"]}
                />
            <div id="rows-container">
                {rowData.map((row, index) => {
                   return <FormRow 
                        rowData={row}
                        widths={["40%", "40%", "12.5%", "5%"]}
                        selectRow={() => this.selectDevice(deviceIds[index])}
                        isSelected={isSelected[row[1]]}
                        openModal={this.props.openModal}
                />})}
            </div>
        </Fragment>
        }
    }

    render() {
        return <div id="device-management-content-container" className="flex-column shadow">
            <div id="device-management-page-header">
                <h3 className="FontSize20">DEVICE</h3>
            </div>
            <div className="flex-apart" style={{ alignItems: "center", marginRight: "1em" }}>
            <SearchFilter filterList={this.filterDevicesList} />
                <div className="flex" style={{
                    width: "1em", justifyContent: "space-between", alignItems: "center", color: "#777777"
                }}>
                </div>
            </div>
            <ul id="device-management-page-device-list" className="overflow overflow-x-hidden" >
                {this.renderDevicesList()}
            </ul>
           </div>
           
    }
}

export default DeviceList